import * as React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";

export default function Hero(props: { title?: string, logo?: string, video?: boolean }) {
	return (
		<>
			<Col
				className="hero"
				id="home"
			>
				{props.video ?
					<iframe
						className="hero-image"
						src="https://www.youtube.com/embed/PEH7IvgMtG8?autoplay=1&mute=1&controls=0&loop=1&playlist=PEH7IvgMtG8"
						frameBorder="0"
						allowFullScreen
						allow="autoplay"
					/> :
					<Image
						className="hero-image"
						alt="EarsOnly Protect voor een bouwhelm"
						src="/images/lifestyle/LifestylePROTECT.png"
					/>
				}
				{props.logo ?

					<div className="hero-content">
						<Image
							className="hero-title"
							src={props.logo}
						/>
					</div>
					:
					<div className="hero-content">

						<h1 className="hero-title">{props.title?.split(' ').map((word, index) => (
							<span key={index} >{word}<br /></span>
						))}</h1>
					</div>
				}
			</Col>

			<Row className="hero-bottom-text">
				<Col>
					Rooted in <b>Dutch craftsmanship</b> and shaped by decades of <b>innovation</b>, EarsOnly builds <b>wearable technology</b> and <b>Custom-Fit hearing protection.</b>
				</Col>
			</Row>
		</>
	);
}
